import { getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  dates: [],
  sites: [],
  siteGroups: [],
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getDates: (state) => {
      // always return the dates ordered
      return state.dates[0] < state.dates[1]
        ? [state.dates[0], state.dates[1]]
        : [state.dates[1], state.dates[0]];
    },
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateDates({ commit }, payload) {
      if (payload.length >= 2) {
        commit("setDates", payload);
      }
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const site_ids = await getSiteIdsForGroups(payload);
      commit("setSites", site_ids);

      return site_ids;
    },
  },
};
